module.exports = __webpack_public_path__ + "img/pdgt_krv.118a2d29.png";